import React from 'react';
import { Button, Dialog, DialogActions, DialogContent } from 'web-library';
import { useTranslation } from 'react-i18next';

export interface NyInfoNotFoundModalProps {
  modelOpen: boolean;
  onClickModalButton: () => void;
}

const MyInfoNotFoundModal = ({ modelOpen, onClickModalButton }: NyInfoNotFoundModalProps) => {
  const { t } = useTranslation();

  return (
    <Dialog open={modelOpen} maxWidth="sm" state="error">
      <DialogContent>
        {t(
          'profile->>MyInfoPage.We are unable to retrieve your particulars from Myinfo. Please proceed to fill up your details.'
        )}
      </DialogContent>
      <DialogActions>
        <Button
          type="button"
          id="button-ok"
          variant="text"
          color="primary"
          onClick={onClickModalButton}
        >
          {t('profile->>MyInfoPage.OK')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default MyInfoNotFoundModal;
